import React, { FC } from 'react';
import styled from 'styled-components';
import { Code02, TextWrapper } from 'ozone/atoms';
import { BodyStyles } from './body-styles';
import { Heading, SubHeading, UnpaddedTextWrapper } from './components';
import { HeadingStyles } from './heading-styles';
import { SupportingStyles } from './supporting-styles';

const Pre = styled(Code02).attrs({
  as: styled(TextWrapper).attrs({ as: 'pre' })``,
})``;

export const Recommendations: FC = () => (
  <>
    <Heading>Recommendations</Heading>
    <UnpaddedTextWrapper>
      Outlined below are a few recommendations that help ensure the components
      we build act smartly as a whole. They are geared towards consistency,
      legibility, and accessibility.
    </UnpaddedTextWrapper>
    <SubHeading>Consistency</SubHeading>
    <UnpaddedTextWrapper>
      Users notice little things that are out of place. We know the phrase "feel
      at home". It's borne out of a feeling of familiarity that brings a sense
      of calm. By making things consistent, we make the user feel the same way
      when experiencing any part of our product. Use only one of the established
      type tokens in any part of the product. The type tokens are:
    </UnpaddedTextWrapper>
    <SupportingStyles />
    <BodyStyles />
    <HeadingStyles />
    <UnpaddedTextWrapper>
      The type tokens are available as react components, and by default refer to
      a styled span element. However, they can be aliased to any component using
      the <Code02>as</Code02> prop. Here's an example:
      <Pre>
        {`
<ProductiveHeading01 as="h6">Some heading</ProductiveHeading01>
<ProductiveHeading01 as={YourCustomComponent}>Some heading</ProductiveHeading01>
      `}
      </Pre>
    </UnpaddedTextWrapper>
    <SubHeading>Legibility</SubHeading>
    <UnpaddedTextWrapper>
      The line heights for every single preset have been chosen to improve
      legibility. Always maintain a right padding of 15% on components that wrap
      text, in order to improve legibility. Letting the text run to the end of a
      container places additional eye travel to the user impeding legibility.
      Prefer to use a minimum padding of 1rem / 16px when possible. The 15% wrap
      rule applies to headings also. In RTL scenarios, the 15% padding should be
      on the left instead. The above demos also follow the same rule. This is
      exposed by a <Code02>TextWrapper</Code02> component.
      <Pre>
        {`
<ProductiveHeading01 as={TextWrapper}>Some heading</ProductiveHeading01>
<TextWrapper>Some text that needs to be legible</TextWrapper>
<TextWrapper as="pre">Some preformmated text</TextWrapper>
      `}
      </Pre>
    </UnpaddedTextWrapper>
    <SubHeading>Accessibility</SubHeading>
    <UnpaddedTextWrapper>
      All the above mentioned styles have in-built affordances to remain
      accessible for people who need them. The line heights are fixed so as to
      avoid unnecessary strain. The 15% wrap rule mentioned above also helps.
    </UnpaddedTextWrapper>
  </>
);
